<template>
    <div class="wrap embedded-survey-result-wrap">
        <div class="top-header">
            <incBack></incBack>
        </div>
        <div class="body-wrap">
            <h4><span class="bold">{{user_name}}</span>님의 현재 집중하고자 하는<br>관심사는 아래와 같습니다.</h4>
            
            <div class="result-rank">
                <ul>
                    <li  v-for="(item,index) in survey_result" :key="index" :class="{'active':item.active}">
                        <div class="clear" @click="toggle(index)">
                            <h1 class="float-left">{{index + 1}}</h1>
                            <h2 class="float-left">{{item.parentSubject}} - {{item.childList[0].childSubject}}</h2>
                            <img v-if="!item.active" src="@/assets/img/arrow-down.png"/>
                            <img v-else src="@/assets/img/arrow-down.png" style="transform:rotate(180deg); top:30%"/>
                        </div>
                        <div v-if="item.active">
                            <p>
                                {{item.parentSubject}} 중에서도 
                                {{item.childList[0].childSubject}}(1순위)
                                <span v-if="index == 0">,{{item.childList[1].childSubject}}(2순위)</span>
                                를 관심사로 선택하셨습니다.
                                {{item.resultText}}
                            </p>
                        </div>
                    </li>
                    <!-- <li :class="{'active':second_active}">
                        <div class="clear" @click="toggle(second_active,1)">
                            <h1 class="float-left">2</h1>
                            <h2 class="float-left">자기관리/웰빙 - 시간관리</h2>
                            <img v-if="!second_active" src="@/assets/img/arrow-down.png"/>
                            <img v-else src="@/assets/img/arrow-down.png" style="transform:rotate(180deg); top:30%"/>
                        </div>
                        <div v-if="second_active">
                            <p>
                                커뮤니케이션(소통) 중에서 기타(팀원들과 커뮤니
                                케이션 방법)(1순위)를 관심사로 선택하셨습니다.
                                상대에 따라 적절하고 효과적인 방법을 활용하여
                                효과적으로 의사소통 합니다. 조직 내에 원활한 
                                소통은 업무 효율성을 높일 뿐 아니라 구성원의 
                                사기를 향상시키고 직무 효능감을 높입니다.
                            </p>
                        </div>
                    </li>
                    <li :class="{'active':third_active}" @click="toggle(third_active,2)">
                        <div class="clear">
                            <h1 class="float-left">3</h1>
                            <h2 class="float-left">커뮤니케이션(소통) - 피드</h2>
                            <img v-if="!third_active" src="@/assets/img/arrow-down.png"/>
                            <img v-else src="@/assets/img/arrow-down.png" style="transform:rotate(180deg); top:30%"/>
                        </div>
                        <div v-if="third_active">
                            <p>
                                커뮤니케이션(소통) 중에서 기타(팀원들과 커뮤니
                                케이션 방법)(1순위)를 관심사로 선택하셨습니다.
                                상대에 따라 적절하고 효과적인 방법을 활용하여
                                효과적으로 의사소통 합니다. 조직 내에 원활한 
                                소통은 업무 효율성을 높일 뿐 아니라 구성원의 
                                사기를 향상시키고 직무 효능감을 높입니다.
                            </p>
                        </div>
                    </li> -->
                </ul>
            </div>
            <div class="result-chart">
                <h4 style="font-size: 18px;">다른 BnB 크루들은<br>어떠한 주제에 더 집중하고 있을까요?</h4>
                <div class="chart">
                    <!-- <p>amchart xy chart 추가 예정</p> -->
                    <xychart :chart_data="xyChartData" ></xychart>
                </div>
            </div>
            <div class="result-slide">
                <h4 style="font-size: 18px;">나와 같은 관심사를 가진 크루들은<br>
                    어떤 고민이 있을까요?</h4>
                <!-- <ul>
                    <li>
                        <h1>리더십</h1>
                        <div class="chart">
                            <piechart :chart_data="pie_chart_data"></piechart>
                        </div>
                    </li>
                    <li>
                        <h1>리더십</h1>
                        <div class="chart">
                            <piechart :chart_data="pie_chart_data"></piechart>
                        </div>
                    </li>
                </ul> -->
                <VueSlickCarousel v-bind="settings" v-if="pie_chart.length">
                    
                    <div class="chart-wrap" v-for="(item,index) in pie_chart" :key="index" style="width:193px; margin-right:25px;">
                        <h1>{{item.categorySubject}}</h1>
                        <piechart :chart_data="item.embeddedSurveyChild"  :legend_id="index"></piechart>
                    </div>
                   
                </VueSlickCarousel>

              

            </div>
            <div class="bnb-btn" v-if="view == 0">
                <p>위 주제를 함께할 전문 코치를 추천 받으시겠어요?</p>
                <button @click="next()" class="active">계속 진행하기</button>
            </div>
        </div>
    </div>
</template>
<script>
    import xychart from "@/components/chart/xy_chart.vue"
    import piechart from "@/components/chart/pie_chart.vue";
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import incBack from "@/components/inc/inc_back.vue";
    export default {
        name :'embedded_survey_result',
        props:{
            view:{
                type:[Number,String],
                default:0
            }
        },
        data: () => ({
            xyChartData:[],
            pie_chart_data:[],
            pie_chart_data_1:[],
            settings:{
                "dots": false,
                "infinite": false,
                "centerMode": false,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "variableWidth": true
            },
            first_active:false,
            second_active:false,
            third_active:false,
            user_name:"",
            user_idx : 0,
            survey_result : [],
            pie_chart:[]
        }),
        components: {
            xychart,
            piechart,
            VueSlickCarousel,
            incBack
        },
        mounted() {
            this.user_idx = this.$store.state.userInfo.userIdx;
            this.user_name = this.$store.state.userInfo.userName;
            this.getEmbeddedResult();
            this.getEmbeddedXyChart();
            this.getEmbeddedPieChart();
        },
        methods: {
            getEmbeddedPieChart(){
                this.axios.get(`/front/embeddedsurveycirclegraph?userIdx=${this.user_idx}`).then((res)=>{
                    if(res.data.success){
                        this.pie_chart = res.data.contentinfo.embeddedSurveyParent;
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            },
            getEmbeddedXyChart(){
                this.axios.get("/front/embeddedsurveybargraph").then((res)=>{
                    // console.log(res);
                    if(res.data.success){
                        this.xyChartData = res.data.data;

                        this.xyChartData.sort((a,b)=>{
                            return parseInt(b.score) - parseInt(a.score);
                        })

                        for(let item of this.xyChartData){
                            item.categorySubject = item.categorySubject.replace("/","/\n");
                            item.categorySubject = item.categorySubject.replace("(","\n(");
                            item.categorySubject = item.categorySubject.replace("/","");
                        }
                        console.log("웰빙",this.xyChartData);
                        
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            },
            getEmbeddedResult(){
                this.axios.get(`/front/userembeddedsurveyreport?userIdx=${this.user_idx}`).then((res)=>{
                    // console.log(res);
                    if(res.data.success){
                        this.survey_result = res.data.data;
                        for(let item of this.survey_result){
                            // console.log(item);
                            this.$store.commit("setEembeddedResult",item.parentSubject)
                            // console.log(this.$store.state.resultText);
                            item.resultText = this.$store.state.resultText;
                            item.active = false;
                        }
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            },
            toggle(index){
                let temp = this.survey_result;
                
                if(temp[index].active){
                    temp[index].active = false;
                }else{
                    temp[index].active = true;
                }


                this.survey_result = [];
                this.survey_result = temp;
            //    item.active = true;
            //    console.log(this.survey_result);
            },
            next(){
                // location.href="/reserve_subject";
                this.$router.push({name:'reserve_subject',params:{rebook:0,coachIdx:0}});
            }
        }
    }
</script>
<style lang="scss" scoped> 



</style>